import React from 'react';
import {PrimaryButton} from 'Components/Button';

import Authenticated from 'Components/Layouts/Authenticated';

import { Loading } from "Components/Partials";
import Users from "Services/Api/Networking/Users";
import { Modal } from "Services";
import StandAloneChatModel from "Components/Partials/Modals/StandAloneChatModel";
import { Link } from "Components/Utilities";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { translation } from "Services/TranslationHelpers";
import OrangeButton from "Components/Button/OrangeButton";
import PaginationBar from "../../Components/Partials/PaginationBar";
import { asset } from "Services/BaseHelpers";
import OrganizationTypeInfo from "Pages/Networking/OrganizationTypeInfo";
import {ModalTrigger} from "Components/Modal";
import RemoteControlConnect from "Components/MainStage/Modals/RemoteControlConnect";
import AOS from 'aos';
import 'aos/dist/aos.css';

export default class WhoWho extends React.Component {

    state = {
        exhibitor: null,
        notFound: null,
        working: false,
        users: [],
        recommendedUsers: [],
        search: '',
        page: 1,
        pageCount: 0,
        total: 0,
    };

    constructor(props) {
        super ( props );

        //get exhibitor data from the url
        this.exhibitor_id = this.props.match.params.exhibitor_id;
    }

    handleSearch = (e) => {
        // Get the new search value
        const searchValue = e.target.value;

        if (this.timeout) clearTimeout(this.timeout);

        // Set the new search value to the state and debounce the fetchUsers function
        this.setState({
            search: searchValue,
        });

        this.timeout = setTimeout(this.fetchUsers, 500);

    }



    handleProfileUpdated = () => {
        this.fetchUsers();
    }

    renderSearchBar = () => {

        return (
            <div className="mx-auto flex justify-center relative z-10 mb-16">
                <input
                    type="text"
                    className={`w-11/12 mt-6 border-0 bg-[#f1efeb] rounded-full text-text-app-light-blue-blue
                        outline-none focus:outline-none focus:border-0 focus:ring-0 font-bold py-3 placeholder-app-light-blue pl-10`}
                    placeholder={translation('misc', 'search')}
                    onChange={this.handleSearch}
                    value={this.state.search}
                />

                <FontAwesomeIcon
                    icon={faSearch}
                    size="1x"
                    className="h-6 w-6 absolute top-9 right-16 text-app-light-blue"
                />
            </div>
        );
    }

    async componentDidMount() {
        AOS.init({
            duration: 1000,
            once: true,
            startEvent: 'DOMContentLoaded',
            easing: 'ease-in-out',
        });
        await this.fetchInitialUsers();
    }

    fetchInitialUsers = async () => {
        this.setState({ working: true });
        const response = await Users.enabled({filter_by_same_person: true, search: this.state.search, page: 1});
        if (response && response.data) {
            // Store top 3 recommended users
            const recommendedUsers = response.data.data.slice(0, 3);
            this.setState({
                recommendedUsers,
                users: response.data,
                working: false,
            });
        }
    }

    fetchUsers = async (page = 1) => {
        this.setState({ working: true });
        const response = await Users.enabled({filter_by_same_person: true, search: this.state.search, page });
        if (response && response.data) {
            this.setState({
                users: response.data,
                working: false,
            });
        }
    }

    navigateChatLink = (user) => {
        Modal.open({
            component: StandAloneChatModel,
            props: {
                user: user
            }
        });
    };

    handlePageChange = async (page) => {
        if (this.createProfileRef) {
            this.createProfileRef.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        await this.fetchUsers(page);
    }

    getRowColors(rowSize = 3) {
        const purple = '#E8DAFF';
        return Array(rowSize).fill(purple);
    }

    AttendeeCard({ user, bgColor, fontColor, onChatClick }) {
        const background = bgColor || '#E8DAFF';
        const textColor = fontColor || '#491D8B';

        return (
            <div key={user.id} data-aos="fade-up">
                <div
                    className="flex items-stretch rounded-lg overflow-hidden shadow-sm"
                    style={{ background: background }}
                >
                    {/* Left: image panel */}
                    <div className="w-2/5 flex-shrink-0">
                        {(() => {
                            const src = user.avatar_path && user.avatar_path.url
                                ? user.avatar_path.url
                                : asset('/images/placeholder-profile.png');
                            return (
                                <img
                                    src={src}
                                    alt={user.name}
                                    className="w-full h-full object-cover"
                                />
                            );
                        })()}
                    </div>

                    {/* Right: content panel */}
                    <div className="flex flex-col flex-grow px-5 py-5 justify-between">
                        <div>
                            <h2 className="text-lg md:text-xl font-bold leading-tight mb-2" style={{ color: textColor }}>
                                {(() => {
                                    const parts = (user.name || '').split(' ');
                                    return (
                                        <>
                                            {parts[0]}
                                            {parts.length > 1 && (
                                                <>
                                                    <br />
                                                    {parts.slice(1).join(' ')}
                                                </>
                                            )}
                                        </>
                                    );
                                })()}
                            </h2>
                            <div className="text-sm" style={{ color: textColor }}>
                                {user.company_name && <span className="font-bold block">{user.company_name}</span>}
                                {user.company_name && user.job_title && <span className="block">{user.job_title}</span>}
                                {!user.company_name && user.job_title && <span className="block">{user.job_title}</span>}
                            </div>
                        </div>

                        <div className="mt-4 flex justify-end">
                            <span
                                className="font-bold cursor-pointer inline-flex items-center text-sm"
                                onClick={() => onChatClick(user)}
                                style={{ color: textColor }}
                            >
                                Full Profile <span className="ml-1">→</span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        const { users, working, recommendedUsers } = this.state;
        const recommended = recommendedUsers;
        const others = users && users.data ? users.data.filter(u => !recommendedUsers.some(r => r.id === u.id)) : [];

        return (
            <Authenticated
                pageTitle="Who's Who"
                pageVideoHeader={ "bupa-banner.mp4" }
                showRegBanner={false}
            >
                <div className="max-w-5xl mx-auto p-5">
                    {/*<div className={"flex flex-col md:flex-row justify-center items-center mb-10"}>*/}
                    {/*    <div className={"w-full md:w-1/2 flex items-center text-5xl justify-center text-center md:text-left md:justify-left text-app-blue"}>*/}
                    {/*        Connect*/}
                    {/*        <br />*/}
                    {/*        with purpose*/}
                    {/*    </div>*/}
                    {/*    <div className={"ml-4 text-2xl text-app-blue w-full md:w-1/2 text-left"}>*/}

                    {/*        <p className="left px-6 text-app-blue my-10 text-lg">*/}
                    {/*            This feature helps you discover attendees who share your interests—making it easy to spark meaningful conversations and build valuable relationships throughout the event.*/}
                    {/*        </p>*/}
                    {/*        <p className="text-left px-6 text-app-blue my-10 text-lg">*/}
                    {/*            To get started, create your profile by clicking the create button below.*/}
                    {/*            Once you're done, you’ll see your personalised matches and can browse the full list of attendees.*/}
                    {/*            Want to connect? Click on a profile to start chatting and make the most of your event experience.*/}
                    {/*        </p>*/}
                    {/*    </div>*/}
                    {/*</div>*/}

                    <div className=" mt-12 mb-6 text-center text-2xl font-bold mx-auto text-app-blue">
                        {/*<img*/}
                        {/*    src={asset('images/agenda-date-banner.gif')}*/}
                        {/*    alt="Agenda Date Banner"*/}
                        {/*    className="w-full h-24 object-cover mt-2 p-4 max-w-4xl mx-auto"*/}
                        {/*/>*/}
                        Attendees
                    </div>

                    <div className="flex justify-center m-auto my-6 w-full text-app-blue">
                        Connect with other attendees at Bupa Symposium 2026.
                        <br />
                        Create your profile to send a message and begin networking.
                    </div>

                    {working && <Loading />}

                    <div className="flex justify-center m-auto mt-6 mb-12 w-full" ref={el => this.createProfileRef = el}>
                        <ModalTrigger
                            component={OrganizationTypeInfo}
                            props={{
                                onProfileUpdated: this.handleProfileUpdated,
                                onClose: () => this.fetchUsers(),
                            }}
                        >
                            <PrimaryButton text={"Connect now"} />
                        </ModalTrigger>
                    </div>

                    {this.renderSearchBar()}

                    {/* Recommended for you section */}
                    {/* Recommended for you section */}
                    {recommended.length > 0 && (
                        <>
                            <h2
                                className="text-4xl text-app-light-blue mt-10 mb-4 text-left"
                                data-aos="fade-up"
                                data-aos-delay="0"
                            >
                                Recommended for you
                            </h2>
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-3 w-full mx-auto mb-10"
                                 data-aos="fade-up"
                                 data-aos-delay="1400">
                                {Array.from({ length: Math.ceil(recommended.length / 3) }).map((_, rowIdx) => {
                                    const rowColors = this.getRowColors();
                                    return recommended.slice(rowIdx * 3, rowIdx * 3 + 3).map((user, colIdx) => {
                                        const bgColor = rowColors[colIdx];
                                        const fontColor = '#491D8B';

                                        return this.AttendeeCard({
                                            user,
                                            bgColor,
                                            fontColor,
                                            onChatClick: this.navigateChatLink,
                                            key: user.id,
                                            'data-aos': 'fade-up',
                                            'data-aos-delay': (rowIdx * 3 + colIdx) * 100

                                        });
                                    });
                                })}
                            </div>
                        </>
                    )}

                    {/* Gap before the rest */}
                    {others.length > 0 && (
                        <div className="mb-8">
                            <h2
                                className="text-4xl  text-app-light-blue mb-4 text-left"
                                data-aos="fade-up"
                                data-aos-delay="1400"
                            >
                                Our Attendees
                            </h2>
                        </div>
                    )}
                    {/* All other attendees */}
                    {(!working && others.length > 0) && (
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-3 w-full mx-auto"
                             data-aos="fade-up"
                             data-aos-delay="1400">
                            {Array.from({ length: Math.ceil(others.length / 3) }).map((_, rowIdx) => {
                                const rowColors = this.getRowColors();
                                return others.slice(rowIdx * 3, rowIdx * 3 + 3).map((user, colIdx) => {
                                    const bgColor = rowColors[colIdx];
                                    const fontColor = '#491D8B';

                                    return this.AttendeeCard({
                                        user,
                                        bgColor,
                                        fontColor,
                                        onChatClick: this.navigateChatLink,
                                        key: user.id,
                                        'data-aos': 'fade-up',
                                        'data-aos-delay': (rowIdx * 3 + colIdx) * 100
                                    });
                                }
                                );
                            })}
                        </div>
                    )}

                    {!working && users && users.data && users.meta && (
                        <PaginationBar
                            total={users.meta.total}
                            pageCount={users.meta.last_page}
                            page={users.meta.current_page}
                            className="my-10"
                            goToPage={this.handlePageChange}
                        />
                    )}
                </div>
            </Authenticated>
        );
    }

    UserAvatar(user, width = 'w-32', height = 'h-32') {
        const className = `${width} ${height} object-cover flex items-center justify-center rounded-lg`;
        const src = user.avatar_path && user.avatar_path.url
            ? user.avatar_path.url
            : asset('/images/placeholder-profile.png');
        return (
            <img
                src={src}
                alt={user.name}
                className={className}
            />
        );
    }
}
